var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-card',{attrs:{"hide-header":""}},[_c('div',{},[_c('app-data-table',{attrs:{"items":_vm.reportRows,"headers":_vm.invoiceTableHeaders,"loading":_vm.loading},on:{"onRowClick":_vm.onRowClick},scopedSlots:_vm._u([{key:"item.InvoiceId",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.InvoiceId)+" "),(item.DeletedOn)?_c('AppChip',{attrs:{"small":"","label":"","color":"red"}},[_vm._v("VOID")]):_vm._e()]}},{key:"item.InvoiceTotal",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.InvoiceTotal.toFixed(2))+" ")]}},{key:"item.TotalPaid",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.TotalPaid.toFixed(2))+" ")]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }